module.exports = __webpack_public_path__ + "img/cloud-slash.3782457c.svg";